import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'

// Custom Directives
import { AutofocusDirective } from './directives/autofocus.directive'
import { DragScrollYDirective } from './directives/drag-scroll-y.directive'

// Custom Pipes
import { SafeHtmlPipe } from './pipes/safe-html.pipe'

/**
 * Module containing commonly used pipes and directives.
 * Import this when you need access to shared pipes and directives.
 *
 * Note: HasPermissionDirective and DragScrollItemDirective should be
 * imported directly from their respective modules when needed.
 */
@NgModule({
  declarations: [AutofocusDirective, DragScrollYDirective, SafeHtmlPipe],
  imports: [CommonModule],
  exports: [
    // Custom directives
    AutofocusDirective,
    DragScrollYDirective,

    // Custom pipes
    SafeHtmlPipe,
  ],
  providers: [DatePipe],
})
export class CorePipesDirectivesModule {}
